import React, { useEffect, useState } from "react";
import Cources from "../components/Homepage/Courses";
import TrainingPartner from "../components/Homepage/Training";
import FAQ from "../components/Homepage/FAQ";
import Layout from "../components/Layout/Layout";
import Testimonials from "../components/testimonials/Testimonials";
import BannerHeroSection from "../components/HeroSection/BannerHeroSection";
import TrainingHero from "../assets/TrainingHero.png";
import axios from "axios";

const Courses = () => {
  const [HomeData, setHomeData] = useState();

  useEffect(() => {
    const getHomeDetails = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_BASE_URL}/home`,
        );
        setHomeData(response?.data.data[0]);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    getHomeDetails();
  }, []);

  return (
    <Layout>
      <BannerHeroSection
        title="All Courses"
        subtitle="Discover our comprehensive training programs designed to enhance your skills and advance your career"
        bannerImage={TrainingHero}
        height="h-64 md:h-80 lg:h-96 xl:h-[500px]"
        className="-mx-4 md:-mx-12 lg:-mx-16 mb-6 md:mb-8 lg:mb-10"
      />
      <Cources />
      {/* <TrainingPartner data={HomeData}/> */}
      <FAQ />
      <Testimonials />
    </Layout>
  );
};
export default Courses;
